import { AppShell, Header, Image, Navbar, Text, Group, Stack, rem, useMantineTheme } from '@mantine/core';
import AppNavbar from './AppNavbar';
import MockFooterData from '../data/mockData/mock-footer-links';
import { Footer } from '@mantine/core';
import AppFooter from './Footer';
import AppHeader from './AppHeader';
import { useState } from 'react';

const AppShellContainer = ({children}) => {
  const [opened, setOpened] = useState(false);
  const theme = useMantineTheme();

  return (
    <AppShell
      navbarOffsetBreakpoint='sm'
      padding="sm"
      navbar={<AppNavbar hidden={opened} />}
      header={<AppHeader hidden={opened} toggleHidden={() => setOpened(!opened)} theme={theme} />}
      footer={<Footer height={150}><AppFooter data={MockFooterData} /></Footer>}
      styles={(theme) => ({
        main: { backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[8] : theme.colors.gray[0] },
      })}
    >
      { children }
    </AppShell>
  );
}

export default AppShellContainer;